import { render, staticRenderFns } from "./visitor_policies.vue?vue&type=template&id=c3880d42&"
import script from "./visitor_policies.vue?vue&type=script&lang=js&"
export * from "./visitor_policies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports